import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Loader2, Plus, Save, Wifi } from "lucide-react";
import { fetchInvoicing, saveInvoicing, testInvoicing } from "@/lib/bf";

const FIELDS = [["name", "Nume firmă"], ["cui", "CUI"], ["bank", "Banca"], ["iban", "Cont IBAN (apare pe mesajele de scadență)"], ["series", "Serie chitanțe (ex. VSB)"], ["ip", "Adresă server NeoManager"], ["port", "Port Web Connector"], ["company", "Companie (exact ca în NeoManager)"], ["gestiune", "ID gestiune"], ["user", "Utilizator integrare"], ["source", "Sursă documente"]];

export default function BFInvoicingFirms() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState("");
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    let on = true;
    fetchInvoicing().then((c) => on && setCfg((x) => x || c)).catch(() => toast.error("Nu am putut încărca firmele"));
    return () => { on = false; };
  }, []);
  if (!cfg) return null;
  const setF = (i, k, v) => setDirty(true) || setCfg({ ...cfg, firms: cfg.firms.map((f, j) => (j === i ? { ...f, [k]: k === "port" ? Number(v.replace(/\D/g, "")) || 0 : v } : f)) });
  const add = () => setDirty(true) || setCfg({ ...cfg, firms: [...cfg.firms, { id: `firma${Date.now().toString(36)}`, name: `Firma ${cfg.firms.length + 1}`, cui: "", bank: "", iban: "", ip: "", port: 0, company: "", gestiune: "", user: "", source: "BF Beauty Trends", series: "", active: true }] });
  const save = () => {
    if (cfg.firms.some((f) => !f.name.trim())) return toast.error("Fiecare firmă trebuie să aibă un nume");
    setBusy("save");
    const { connected, ...body } = cfg;
    saveInvoicing(body).then(() => { toast.success("Firme salvate"); setDirty(false); return fetchInvoicing().then(setCfg); })
      .catch((e) => toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Nu am putut salva")).finally(() => setBusy(""));
  };
  const test = (f) => { setBusy(f.id); testInvoicing(f.id).then((r) => (r.ok ? toast.success(r.message) : toast.error(r.message))).catch(() => toast.error("Salvează întâi firma")).finally(() => setBusy("")); };
  return (
    <section className="invite-box" data-testid="bf-inv-firms">
      <h3><Building2 size={18} /> Firmele de facturare</h3>
      <p className="st-hint">Agentul alege pe ce firmă se facturează comanda. Datele de conexiune le primiți de la consultantul NeoManager. Parola utilizatorului de integrare o cerem separat, printr-un formular securizat, nu se scrie aici.</p>
      <div className="bf-inv-firms">
        {cfg.firms.map((f, i) => (
          <div key={f.id} className="bf-inv-firm" data-testid={`bf-inv-firm-${f.id}`}>
            <header>
              <label><input type="radio" name="def-firm" checked={cfg.default_firm === f.id} onChange={() => setDirty(true) || setCfg({ ...cfg, default_firm: f.id })} data-testid={`bf-inv-default-${f.id}`} /> implicită</label>
              <label><input type="checkbox" checked={f.active} onChange={(e) => setF(i, "active", e.target.checked)} data-testid={`bf-inv-active-${f.id}`} /> activă</label>
              <em className={cfg.connected?.[f.id] ? "is-ok" : ""}>{cfg.connected?.[f.id] ? "date complete" : "neconectată"}</em>
            </header>
            {FIELDS.map(([k, label]) => (
              <label key={k} className="bf-inv-field">
                <span>{label}</span>
                <input value={k === "port" ? f.port || "" : f[k]} onChange={(e) => setF(i, k, e.target.value)} data-testid={`bf-inv-${k}-${f.id}`} />
              </label>
            ))}
            <button type="button" className="st-btn st-btn--ghost" onClick={() => test(f)} disabled={busy === f.id || dirty} title={dirty ? "Salvează întâi modificările" : ""} data-testid={`bf-inv-test-${f.id}`}>
              {busy === f.id ? <Loader2 size={14} className="animate-spin" /> : <Wifi size={14} />} Testează serverul
            </button>
          </div>
        ))}
      </div>
      <div className="share-actions">
        <button type="button" className="st-btn st-btn--ghost" onClick={add} data-testid="bf-inv-add-firm"><Plus size={14} /> Adaugă firmă</button>
        <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy === "save"} data-testid="bf-inv-save">
          {busy === "save" ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează firmele
        </button>
      </div>
    </section>
  );
}
